import React from "react";
import Card from "react-bootstrap/Card";

function DesignCard(props) {
  return (
    <a style={{ textDecoration: "none"}} href={props.link}>
    <Card className="design-card-view">
      <Card.Img src={props.imgPath} className="design-card-img" />
      <Card.Body className="d-flex flex-column">
        <Card.Title>{props.title}</Card.Title>
        {/* <Card.Text style={{ textAlign: "left" }}>
          {props.description}
        </Card.Text> */}
      </Card.Body>
    </Card>
    </a>
  );
}
export default DesignCard;
